import React from 'react';
import { string, shape } from 'prop-types';

export default function OpshopTile({ item }) {
    const hours = item.hours.split('\r\n');
    return (
        <div className="c-opshop-tile c-content-tile tile-bg-1">
            <div className="tile-content">
                <p className="location">{item.location}</p>
                <h3 className="display">{item.title}</h3>
                <p className="summary">{item.excerpt}</p>
                {item.phone && <p className="p-small">Phone: {item.phone}</p>}
                <p className={`p-small ${item.phone ? 'no-gap' : ''}`}>Opening Hours</p>
                {hours.map(text => <p className="p-small no-gap">{text}</p>)}
            </div>
        </div>
    );
}

OpshopTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        location: string.isRequired,
        title: string.isRequired,
        excerpt: string.isRequired,
        phone: string,
        hours: string.isRequired
    }).isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/tiles/OpshopTile.jsx